import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {EixoService} from "../../../services/eixo/eixo.service";
import {Eixo} from "../../../core/eixo";


@Component({
    selector: 'combo-eixo',
    templateUrl: './combo-eixo.component.html',
    styleUrls: ['./combo-eixo.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboEixoComponent implements OnInit {

    @ViewChild('comboEixo', {static: false}) comboEixo;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private eixoService: EixoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.eixoService.getAll().subscribe((eixos: Eixo[]) => {
                this.dados = eixos;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }


}
